




import {Mixins, Component, Prop } from "vue-property-decorator";
import UserMixin from '../../../mixins/UserMixin';
import UserIcon from "../../common/UserIcon.vue";
import SimpleTag from "@share/common/SimpleTag.vue";

@Component({
    components: {UserIcon, SimpleTag}
})
export default class Participant extends Mixins(UserMixin) {

    @Prop({ default: true }) clickable: boolean;

}
